export default __webpack_public_path__ + "static/media/servicing_image_mobile.c69c2ba5.png";